import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const MODULO = "CobrosSuscripciones";

const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const convertirAMayuscula = (valor = "") =>
  String(valor).toLocaleUpperCase("es-CO");

const normalizarMayuscula = (valor = "") =>
  convertirAMayuscula(valor)
    .replace(/\s+/g, " ")
    .trim();

const leerSesionLocal = () => {
  try {
    const permisosStorage = localStorage.getItem("permisos");
    const usuarioStorage = localStorage.getItem("usuario");
    const userStorage = localStorage.getItem("user");
    const usuariosStorage = localStorage.getItem("usuarios");

    return permisosStorage
      ? JSON.parse(permisosStorage)
      : usuarioStorage
        ? JSON.parse(usuarioStorage)
        : userStorage
          ? JSON.parse(userStorage)
          : usuariosStorage
            ? JSON.parse(usuariosStorage)
            : {};
  } catch (error) {
    console.error("Error leyendo información local:", error);
    return {};
  }
};

const obtenerModulo = (nombreModulo) => {
  try {
    const data = leerSesionLocal();

    const modulos = Array.isArray(data)
      ? data
      : data?.modulos ||
        data?.permisos ||
        data?.usuario?.modulos ||
        data?.usuario?.permisos ||
        data?.user?.modulos ||
        data?.user?.permisos ||
        [];

    const buscado = normalizarTexto(nombreModulo);

    return (
      modulos.find((modulo) => {
        const nombre =
          modulo?.nombreModulo ||
          modulo?.modulo ||
          modulo?.nombre ||
          modulo?.moduloObjectId?.nombreModulo ||
          modulo?.moduloObjectId?.nombre ||
          "";

        return normalizarTexto(nombre) === buscado;
      }) || {}
    );
  } catch (error) {
    console.error("Error leyendo permisos:", error);
    return {};
  }
};

const obtenerRolNombre = () => {
  const data = leerSesionLocal();

  const rol =
    data?.rolObjectId?.nombreRol ||
    data?.rol?.nombreRol ||
    data?.rol?.nombre ||
    data?.rol ||
    data?.role ||
    data?.nombreRol ||
    data?.usuario?.rolObjectId?.nombreRol ||
    data?.usuario?.rol?.nombreRol ||
    data?.usuario?.rol?.nombre ||
    data?.usuario?.rol ||
    data?.user?.rolObjectId?.nombreRol ||
    data?.user?.rol?.nombreRol ||
    data?.user?.rol?.nombre ||
    data?.user?.rol ||
    "";

  return String(rol).trim().toUpperCase();
};

const parsearListaDias = (valor = "") => {
  const dias = String(valor)
    .split(",")
    .map((item) => Number(String(item).trim()))
    .filter((numero) => Number.isFinite(numero) && numero >= 0);

  return Array.from(new Set(dias)).sort((a, b) => b - a);
};


const RegistrarConfiguracionCobros = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const edit = Boolean(id);

  const [nombreConfiguracion, setNombreConfiguracion] = useState(
    "CONFIGURACION_GENERAL"
  );
  const [monedaPrincipal, setMonedaPrincipal] = useState("COP");
  const [diasAvisoTexto, setDiasAvisoTexto] = useState("7, 3, 1");
  const [diasGraciaDefault, setDiasGraciaDefault] = useState("0");
  const [permitirPeriodoGracia, setPermitirPeriodoGracia] = useState(true);
  const [bloquearAlVencer, setBloquearAlVencer] = useState(true);
  const [permitirCargaComprobante, setPermitirCargaComprobante] = useState(true);
  const [
    requiereAprobacionManualPago,
    setRequiereAprobacionManualPago,
  ] = useState(true);
  const [mensajePorVencer, setMensajePorVencer] = useState(
    "Tu suscripción está próxima a vencer."
  );
  const [mensajeVencido, setMensajeVencido] = useState(
    "Tu suscripción ha vencido. Renueva tu acceso para continuar usando MrGestor."
  );
  const [emailSoporte, setEmailSoporte] = useState("");
  const [telefonoSoporte, setTelefonoSoporte] = useState("");
  const [activo, setActivo] = useState(true);

  const [loading, setLoading] = useState(false);

  const moduloCobros = useMemo(() => obtenerModulo(MODULO), []);

  const puedeCrear =
    moduloCobros?.puedeCrear === true ||
    moduloCobros?.crear === true ||
    moduloCobros?.create === true;

  const puedeLeer =
    moduloCobros?.puedeLeer === true ||
    moduloCobros?.leer === true ||
    moduloCobros?.read === true;

  const puedeActualizar =
    moduloCobros?.puedeActualizar === true ||
    moduloCobros?.actualizar === true ||
    moduloCobros?.editar === true ||
    moduloCobros?.update === true;

  const rolNombre = useMemo(() => obtenerRolNombre(), []);
  const esInstructor = rolNombre === "INSTRUCTOR";
  const tienePermisoFormulario = edit ? puedeActualizar : puedeCrear;

  const authConfig = () => {
    const token = localStorage.getItem("token");

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const manejarErrorSesion = (error) => {
    if (error?.response?.status === 401) {
      Swal.fire({
        icon: "warning",
        title: "Sesión expirada",
        text: "Por favor inicia sesión nuevamente.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        localStorage.removeItem("token");
        navigate("/", { replace: true });
      });

      return true;
    }

    return false;
  };


  const cleanData = () => {
    setNombreConfiguracion("CONFIGURACION_GENERAL");
    setMonedaPrincipal("COP");
    setDiasAvisoTexto("7, 3, 1");
    setDiasGraciaDefault("0");
    setPermitirPeriodoGracia(true);
    setBloquearAlVencer(true);
    setPermitirCargaComprobante(true);
    setRequiereAprobacionManualPago(true);
    setMensajePorVencer("Tu suscripción está próxima a vencer.");
    setMensajeVencido(
      "Tu suscripción ha vencido. Renueva tu acceso para continuar usando MrGestor."
    );
    setEmailSoporte("");
    setTelefonoSoporte("");
    setActivo(true);
  };

  const handleCancelOrClean = () => {
    if (edit) {
      navigate("/cobros/configuracion");
    } else {
      cleanData();
    }
  };

  useEffect(() => {
    const cargarConfiguracion = async () => {
      if (!id) return;

      if (!puedeLeer && !puedeActualizar) {
        Swal.fire(
          "Sin permisos",
          "No tiene permisos para consultar la configuración de cobros.",
          "warning"
        );
        return;
      }

      try {
        setLoading(true);

        const { data } = await axios.get(
          `/api/configuracioncobros/listid/${id}`,
          authConfig()
        );

        const configuracion = data?.message;

        if (!data?.ok || !configuracion) {
          throw new Error(
            data?.message || "No se pudo cargar la configuración."
          );
        }

        setNombreConfiguracion(
          configuracion.nombreConfiguracion || "CONFIGURACION_GENERAL"
        );
        setMonedaPrincipal(configuracion.monedaPrincipal || "COP");
        setDiasAvisoTexto(
          Array.isArray(configuracion.diasAvisoVencimiento)
            ? configuracion.diasAvisoVencimiento.join(", ")
            : "7, 3, 1"
        );
        setDiasGraciaDefault(
          String(configuracion.diasGraciaDefault ?? 0)
        );
        setPermitirPeriodoGracia(
          configuracion.permitirPeriodoGracia !== false
        );
        setBloquearAlVencer(configuracion.bloquearAlVencer !== false);
        setPermitirCargaComprobante(
          configuracion.permitirCargaComprobante !== false
        );
        setRequiereAprobacionManualPago(
          configuracion.requiereAprobacionManualPago !== false
        );
        setMensajePorVencer(configuracion.mensajePorVencer || "");
        setMensajeVencido(configuracion.mensajeVencido || "");
        setEmailSoporte(configuracion.emailSoporte || "");
        setTelefonoSoporte(configuracion.telefonoSoporte || "");
        setActivo(configuracion.activo !== false);
      } catch (error) {
        console.error("Error cargando configuración:", error);

        if (manejarErrorSesion(error)) return;

        Swal.fire(
          "Error",
          error.response?.data?.message ||
            error.message ||
            "No se pudo cargar la configuración.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    cargarConfiguracion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const actions = async (e) => {
    e.preventDefault();

    if (!tienePermisoFormulario) {
      Swal.fire(
        "Sin permisos",
        edit
          ? "No tiene permisos para actualizar la configuración."
          : "No tiene permisos para crear la configuración.",
        "warning"
      );
      return;
    }

    if (esInstructor) {
      Swal.fire(
        "Acceso restringido",
        "La configuración de cobros corresponde a administración.",
        "warning"
      );
      return;
    }

    const payload = {
      nombreConfiguracion: nombreConfiguracion.trim() || "CONFIGURACION_GENERAL",
      monedaPrincipal: normalizarMayuscula(monedaPrincipal || "COP"),
      diasAvisoVencimiento: parsearListaDias(diasAvisoTexto),
      diasGraciaDefault: Number(diasGraciaDefault || 0),
      permitirPeriodoGracia,
      bloquearAlVencer,
      permitirCargaComprobante,
      requiereAprobacionManualPago,
      mensajePorVencer: mensajePorVencer.trim(),
      mensajeVencido: mensajeVencido.trim(),
      emailSoporte: emailSoporte.trim(),
      telefonoSoporte: telefonoSoporte.trim(),
      activo,
    };

    try {
      setLoading(true);

      const { data } = edit
        ? await axios.put(
            `/api/configuracioncobros/update/${id}`,
            payload,
            authConfig()
          )
        : await axios.post(
            "/api/configuracioncobros/add",
            payload,
            authConfig()
          );

      await Swal.fire({
        icon: "success",
        title:
          data?.message ||
          (edit
            ? "Configuración actualizada correctamente"
            : "Configuración creada correctamente"),
        showConfirmButton: false,
        timer: 1700,
      });

      navigate("/cobros/configuracion");
    } catch (error) {
      console.error("Error guardando configuración:", error);

      if (manejarErrorSesion(error)) return;

      Swal.fire({
        icon: "error",
        title: edit ? "Error al actualizar" : "Error al registrar",
        text:
          error.response?.data?.message ||
          error.message ||
          "No se pudo guardar la configuración.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (esInstructor) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          La configuración de cobros está disponible únicamente para
          administración.
        </div>
        <button
          className="btn btn-dark"
          onClick={() => navigate("/cobros/configuracion")}
        >
          Volver
        </button>
      </div>
    );
  }

  if (edit && !puedeActualizar) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          No tiene permisos para actualizar la configuración de cobros.
        </div>
        <button
          className="btn btn-dark"
          onClick={() => navigate("/cobros/configuracion")}
        >
          Volver
        </button>
      </div>
    );
  }

  if (!edit && !puedeCrear) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          No tiene permisos para crear la configuración de cobros.
        </div>
        <button
          className="btn btn-dark"
          onClick={() => navigate("/cobros/configuracion")}
        >
          Volver
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <h4 className="mb-1 fw-semibold">
                {edit
                  ? "Actualizar Configuración de Cobros"
                  : "Registrar Configuración de Cobros"}
              </h4>
              <p className="mb-0 text-secondary small">
                Define las reglas generales de vencimiento, pagos y
                notificaciones.
              </p>
            </div>

            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-outline-dark"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>

              <button
                type="button"
                className={`btn ${
                  edit ? "btn-outline-danger" : "btn-outline-dark"
                }`}
                onClick={handleCancelOrClean}
                disabled={loading}
              >
                <i
                  className={`fa-solid ${
                    edit ? "fa-xmark" : "fa-eraser"
                  } me-2`}
                ></i>
                {edit ? "Cancelar" : "Limpiar"}
              </button>
            </div>
          </div>
        </div>

        <form onSubmit={actions}>
          <div className="row g-3">
            <div className="col-12 col-xl-8">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <h6 className="mb-0 fw-semibold">Configuración general</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <div className="col-12 col-md-8">
                    <label className="form-label small text-secondary text-uppercase">
                      Nombre *
                    </label>
                    <input
                      className="form-control"
                      value={nombreConfiguracion}
                      onChange={(e) =>
                        setNombreConfiguracion(e.target.value)
                      }
                      required
                    />
                  </div>

                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary text-uppercase">
                      Moneda *
                    </label>
                    <input
                      className="form-control"
                      value={monedaPrincipal}
                      onChange={(e) =>
                        setMonedaPrincipal(
                          convertirAMayuscula(e.target.value)
                        )
                      }
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Días aviso vencimiento
                    </label>
                    <input
                      className="form-control"
                      value={diasAvisoTexto}
                      onChange={(e) => setDiasAvisoTexto(e.target.value)}
                      placeholder="7, 3, 1"
                    />
                    <div className="form-text">
                      Separados por coma.
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Días de gracia por defecto
                    </label>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      value={diasGraciaDefault}
                      onChange={(e) =>
                        setDiasGraciaDefault(e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mt-3">
                <h6 className="mb-0 fw-semibold">Mensajes</h6>
                <hr className="my-3" />

                <div className="mb-3">
                  <label className="form-label small text-secondary text-uppercase">
                    Mensaje por vencer
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={mensajePorVencer}
                    onChange={(e) => setMensajePorVencer(e.target.value)}
                  />
                </div>

                <div>
                  <label className="form-label small text-secondary text-uppercase">
                    Mensaje vencido
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={mensajeVencido}
                    onChange={(e) => setMensajeVencido(e.target.value)}
                  />
                </div>
              </div>

              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mt-3">
                <h6 className="mb-0 fw-semibold">Soporte</h6>
                <hr className="my-3" />

                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Email soporte
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      value={emailSoporte}
                      onChange={(e) => setEmailSoporte(e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Teléfono soporte
                    </label>
                    <input
                      className="form-control"
                      value={telefonoSoporte}
                      onChange={(e) => setTelefonoSoporte(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-xl-4">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <h6 className="mb-0 fw-semibold">Reglas</h6>
                <hr className="my-3" />

                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={permitirPeriodoGracia}
                    onChange={(e) =>
                      setPermitirPeriodoGracia(e.target.checked)
                    }
                    id="permitirPeriodoGracia"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="permitirPeriodoGracia"
                  >
                    Permitir periodo de gracia
                  </label>
                </div>

                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={bloquearAlVencer}
                    onChange={(e) => setBloquearAlVencer(e.target.checked)}
                    id="bloquearAlVencer"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="bloquearAlVencer"
                  >
                    Bloquear al vencer
                  </label>
                </div>

                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={permitirCargaComprobante}
                    onChange={(e) =>
                      setPermitirCargaComprobante(e.target.checked)
                    }
                    id="permitirCargaComprobante"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="permitirCargaComprobante"
                  >
                    Permitir carga de comprobante
                  </label>
                </div>

                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={requiereAprobacionManualPago}
                    onChange={(e) =>
                      setRequiereAprobacionManualPago(e.target.checked)
                    }
                    id="requiereAprobacionManualPago"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="requiereAprobacionManualPago"
                  >
                    Requiere aprobación manual del pago
                  </label>
                </div>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={activo}
                    onChange={(e) => setActivo(e.target.checked)}
                    id="activo"
                  />
                  <label className="form-check-label" htmlFor="activo">
                    Configuración activa
                  </label>
                </div>

                <div className="alert alert-light border mt-4 mb-0 small text-secondary">
                  Para la operación normal de MrGestor se recomienda mantener
                  una sola configuración general activa.
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mt-3">
            <div className="row g-2">
              <div className="col-12 col-md-6">
                <button
                  type="submit"
                  className="btn btn-dark w-100 fw-semibold py-2"
                  disabled={loading || !tienePermisoFormulario}
                >
                  <i
                    className={`fa-solid ${
                      loading ? "fa-spinner fa-spin" : "fa-floppy-disk"
                    } me-2`}
                  ></i>
                  {loading
                    ? "Guardando…"
                    : edit
                      ? "Guardar cambios"
                      : "Registrar configuración"}
                </button>
              </div>

              <div className="col-12 col-md-6">
                <button
                  type="button"
                  className={`btn w-100 fw-semibold py-2 ${
                    edit ? "btn-outline-danger" : "btn-outline-secondary"
                  }`}
                  onClick={handleCancelOrClean}
                  disabled={loading}
                >
                  {edit ? "Cancelar" : "Limpiar"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrarConfiguracionCobros;
